import { useState } from "react";

/**
 * Resolves one of the static portal mount points from app/templates/index.html.
 *
 * The lookup happens in a state initializer so it runs once per component
 * instead of on every render. The element is available for the first paint and
 * keeps the same identity for the life of the component, so effects can list it
 * as a dependency without re-running.
 */
export function usePortalMount(id: string) {
  const [element] = useState(() => document.getElementById(id));
  return element;
}
